import { useAuth } from "@workos-inc/authkit-react";
import { isNarrativeCitationsEnabled } from "../../../features/narrative-citations/featureFlag";

export interface NarrativeCitationsState {
  enabled: boolean;
  loaded: boolean;
}

export function useNarrativeCitationsEnabled(): NarrativeCitationsState {
  const { featureFlags, isLoading } = useAuth();
  return {
    enabled: isNarrativeCitationsEnabled(featureFlags),
    loaded: !isLoading,
  };
}
